"use strict";

Object.defineProperty(exports, "__esModule", {
  value: !0
});
var e,
  r = require("styled-components"),
  t = ((e = r) && "object" == typeof e && "default" in e && e.default, require("./_commonjsHelpers-7f6ebd13.js"));
require("lodash");
var o,
  p = require("./styled.helpers-645c7a46.js"),
  s = {
    bigDestktop: 1800,
    macScreen: 1440,
    tabletLand: 1200,
    tabletPort: 900,
    phone: 600
  },
  n = function (e, p) {
    return function () {
      return r.css(o || (o = t._taggedTemplateLiteral(["\n  @media screen and (", ": ", "em) {\n    ", "\n  }\n"])), e, p / 16, r.css.apply(void 0, arguments));
    };
  },
  i = function () {
    for (var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : "min-width", r = {}, o = 0, p = Object.entries(s); o < p.length; o++) {
      var i = t._slicedToArray(p[o], 2),
        a = i[0],
        l = i[1];
      r[a] = n(e, l);
    }
    return r;
  };
i.min = i("min-width"), i.max = i("max-width"), exports.color = p.color, exports.fullWidth = p.fullWidth, exports.propIs = p.propIs, exports.propOr = p.propOr, exports.propsOr = p.propsOr, exports.theme = p.theme, exports.themeOr = p.themeOr, exports.withProp = p.withProp, exports.media = i;